import { useState, useEffect, useRef } from 'react';

const testimonials = [
  {
    name: 'Elif Şahin',
    location: 'İstanbul',
    rating: 5,
    text: 'Kız kardeşime doğum günü hediyesi olarak isim kolye yaptırdım. Tam olarak hayal ettiğim gibi çıktı, hatta daha güzel. İşçilik mükemmel, her detay özenle düşünülmüş. Kesinlikle tekrar sipariş vereceğim.',
    design: 'İsim Kolye – 14 Ayar Sarı Altın',
    avatar: 'E',
  },
  {
    name: 'Zeynep Kaya',
    location: 'Ankara',
    rating: 5,
    text: 'Nişanım için özel bir yüzük tasarlatmak istedim ama ne istediğimi tam olarak anlatamıyordum. Sara Kuyumculuk ekibi bana doğru soruları sordu, hayal ettiğimden bile güzel bir yüzük ortaya çıktı.',
    design: 'Özel Tasarım Nişan Yüzüğü',
    avatar: 'Z',
  },
  {
    name: 'Selin Arslan',
    location: 'İzmir',
    rating: 5,
    text: 'Annem için yıldönümü hediyesi olarak harf kolye sipariş verdim. Süreç boyunca her aşamada bilgilendirildim. Ürün geldiğinde ambalaj bile çok şık ve özeldi. Annem çok sevdi, ben de çok sevdim!',
    design: 'Harf Kolye – 18 Ayar Rose Altın',
    avatar: 'S',
  },
  {
    name: 'Merve Demir',
    location: 'Gaziantep',
    rating: 5,
    text: 'Kendi kendime bir şey yaptırmak istedim, uzun süredir düşünüyordum. Sonunda aradım, çok sıcak karşılandım. Tasarım sürecinde fikrimle oynamamı sağladılar. Şimdi boynumdan hiç çıkarmıyorum.',
    design: 'Özel Tarih Bileklik – Gümüş 925',
    avatar: 'M',
  },
  {
    name: 'Ayşe Yılmaz',
    location: 'Hatay',
    rating: 5,
    text: 'Yerel bir marka olduğu için denedim ama kalite açısından çok şaşırdım. Gerçekten premium hissettiriyor. Fiyat-kalite dengesi de çok iyi. Çevremdeki herkese tavsiye ediyorum.',
    design: 'İsim Kolye + Bileklik Set',
    avatar: 'A',
  },
  {
    name: 'Büşra Çelik',
    location: 'Adana',
    rating: 5,
    text: 'WhatsApp\'tan yazdım, çok hızlı dönüş yaptılar. Tasarım taslağını gönderip onayımı aldılar. Ürün tesliminde özel bir kutu içinde geldi, hediye gibi paketlenmişti. Harika bir deneyimdi.',
    design: 'Özel Tasarım Yüzük – Beyaz Altın',
    avatar: 'B',
  },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 5000);
  };

  useEffect(() => {
    if (!isPaused) startInterval();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isPaused]);

  const goTo = (i: number) => {
    setActive(i);
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (!isPaused) startInterval();
  };

  const prev = () => goTo((active - 1 + testimonials.length) % testimonials.length);
  const next = () => goTo((active + 1) % testimonials.length);

  const t = testimonials[active];

  return (
    <section
      className="py-20 md:py-28 px-6 md:px-12 bg-luxury-surface"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4 font-sans">
            Müşteri Yorumları
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight">
            Onlar Anlatsın
          </h2>
          <p className="text-white/40 text-sm md:text-base font-sans mt-4 max-w-xl mx-auto">
            Her takı, bir hikaye. Her müşteri, bir deneyim.
          </p>
        </div>

        {/* Testimonial Card */}
        <div className="relative">
          <div className="border border-luxury-border rounded-lg p-8 md:p-12 bg-luxury-black/40 transition-all duration-500">
            {/* Quote Icon */}
            <div className="w-10 h-10 flex items-center justify-center mb-6">
              <i className="ri-double-quotes-l text-gold text-3xl opacity-60" />
            </div>

            {/* Stars */}
            <div className="flex items-center gap-1 mb-6">
              {Array.from({ length: t.rating }).map((_, i) => (
                <div key={i} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-gold text-sm" />
                </div>
              ))}
            </div>

            {/* Text */}
            <p className="font-serif text-white text-lg md:text-xl leading-relaxed mb-8 italic">
              &ldquo;{t.text}&rdquo;
            </p>

            {/* Bottom Row */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full border border-gold/40 bg-gold/10 flex-shrink-0">
                  <span className="font-serif text-gold text-lg">{t.avatar}</span>
                </div>
                <div>
                  <p className="text-white font-sans text-sm font-medium">{t.name}</p>
                  <p className="text-white/40 font-sans text-xs">{t.location}</p>
                </div>
              </div>
              {/* Design tag */}
              <span className="inline-block border border-gold/20 text-gold/60 text-xs font-sans px-4 py-1.5 rounded-sm whitespace-nowrap">
                {t.design}
              </span>
            </div>
          </div>

          {/* Nav Arrows */}
          <button
            onClick={prev}
            className="absolute -left-4 md:-left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center border border-luxury-border rounded-full bg-luxury-black hover:border-gold/40 hover:text-gold text-white/50 transition-all duration-300 cursor-pointer"
            aria-label="Önceki"
          >
            <i className="ri-arrow-left-s-line text-lg" />
          </button>
          <button
            onClick={next}
            className="absolute -right-4 md:-right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center border border-luxury-border rounded-full bg-luxury-black hover:border-gold/40 hover:text-gold text-white/50 transition-all duration-300 cursor-pointer"
            aria-label="Sonraki"
          >
            <i className="ri-arrow-right-s-line text-lg" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2.5 mt-10">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`transition-all duration-300 rounded-full cursor-pointer ${
                i === active
                  ? 'w-6 h-1.5 bg-gold'
                  : 'w-1.5 h-1.5 bg-white/20 hover:bg-white/40'
              }`}
              aria-label={`${i + 1}. yorum`}
            />
          ))}
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-3 gap-4 mt-14 border-t border-luxury-border pt-12">
          {[
            { value: '500+', label: 'Mutlu Müşteri' },
            { value: '5.0', label: 'Ortalama Puan' },
            { value: '%100', label: 'Özel Tasarım' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-serif text-3xl md:text-4xl text-gold mb-1">
                {stat.value}
              </p>
              <p className="text-white/40 text-xs md:text-sm font-sans">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}